/**
 * Here Customer, WorkOrder and Technician are fixed to handle widget on the dashboard
 */
export enum widgetType {
    customer = 'Customer',
    workOrder = 'WorkOrder',
    technician = 'Technician',
    default = 'Default'
}